document.addEventListener('DOMContentLoaded', function () {
  // Initial setup for newsletter form if it already exists
  setupNewsletterFormAccessibility();

  // Watch for dynamic elements being added
  const observer = new MutationObserver(function (mutationsList) {
    mutationsList.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return; // Only element nodes

        /**
         * START
         * Fix: Newsletter form submit button accessibility
         * Accessibility Tool: AXEDEV
         */
        // Check if the added node contains or is a newsletter form
        if (node.querySelector && node.querySelector('.team-newsletter-card .team-newsletter__form')) {
          setupNewsletterFormAccessibility();
        }

        // Check if the added node is within a newsletter form
        if (node.closest && node.closest('.team-newsletter-card .team-newsletter__form')) {
          setupNewsletterFormAccessibility();
        }
        /**
         * END
         * Fix: Newsletter form submit button accessibility
         * Accessibility Tool: AXEDEV
         */

        /**
         * START
         * Fix: ARIA role should be appropriate for the element
         * Page: All
         * Accessibility Tool: AXEDEV
         */
        const chatButtonIframe = node.querySelector('iframe#chat-button');
        if (chatButtonIframe) {
          chatButtonIframe.removeAttribute('role');
          chatButtonIframe.removeAttribute('aria-live');
        }
        /**
         * END
         * Fix: ARIA role should be appropriate for the element
         * Page: All
         * Accessibility Tool: AXEDEV
         */

        /**
         * START
         * Fix: Images must have alternative text
         * Page: Product view
         * Accessibility Tool: AXEDEV
         */
        const tag = node.tagName.toLowerCase();
        if (tag === 'img') {
          if (node.classList.contains('xse-image') || node.classList.contains('xse-image-alt')) {
            setXseImageAlt(node);
          }
        }

        // Fix image alt if images are nested inside added node
        const imgs = node.querySelectorAll?.('img.xse-image, img.xse-image-alt');
        imgs?.forEach((img) => {
          setXseImageAlt(img);
        });
        /**
         * END
         * Fix: Images must have alternative text
         * Page: Product view
         * Accessibility Tool: AXEDEV
         */

        /**
         * START
         * Fix1: <ul> and <ol> must only directly contain <li>, <script> or <template> elements
         * Fix2: <li> elements must be contained in a <ul> or <ol>
         * Page: Product view
         * Accessibility Tool: AXEDEV
         */
        const xCarouselContent = node.querySelector('x-carousel-content');
        if (xCarouselContent) {
          customElements.whenDefined('x-carousel-content').then(() => {
            requestAnimationFrame(() => {
              const shadowCarouselContent = xCarouselContent.shadowRoot;
              if (shadowCarouselContent) {
                const ul = shadowCarouselContent.querySelector('ul.x-carousel-content');
                if (ul && !ul.hasAttribute('role')) {
                  ul.setAttribute('role', 'list')
                }
              } else {
                console.warn('<x-carousel-content> has no open shadowRoot or hasn\'t rendered it yet');
              }
              const xCarouselItems = xCarouselContent.querySelectorAll('x-carousel-item');
              const strings = window.themeStrings ?? {};
              xCarouselItems.forEach((carouselItem) => {
                if (carouselItem) {
                  const xseProductName = carouselItem.querySelector('section.xse-product-info span.xse-prod-name')?.textContent.trim();
                  const xseImageContainerSection = carouselItem.querySelector('section.xse-image-container');
                  const xseProductLabelContainerSection = carouselItem.querySelector('section.xse-product-label-container');
                  const xseProductInfoSection = carouselItem.querySelector('section.xse-product-info');
                  const xseProductTopSection = carouselItem.querySelector('section.xse-product-top');
                  const xsePriceContainerSection = carouselItem.querySelector('section.xse-price-container');

                  if (xseImageContainerSection && !xseImageContainerSection.getAttribute('aria-label')) {
                    xseImageContainerSection.setAttribute('aria-label', (strings.productImagesFor ?? 'Product images for {{ name }}').replace('{{ name }}', xseProductName));
                  }

                  if (xseProductLabelContainerSection && !xseProductLabelContainerSection.getAttribute('aria-label')) {
                    xseProductLabelContainerSection.setAttribute('aria-label', (strings.productLabelsFor ?? 'Product labels for {{ name }}').replace('{{ name }}', xseProductName));
                  }

                  if (xseProductInfoSection && !xseProductInfoSection.getAttribute('aria-label')) {
                    xseProductInfoSection.setAttribute('aria-label', (strings.productDetailsFor ?? 'Product details for {{ name }}').replace('{{ name }}', xseProductName));
                  }

                  if (xseProductTopSection && !xseProductTopSection.getAttribute('aria-label')) {
                    xseProductTopSection.setAttribute('aria-label', `${xseProductName}`);
                  }

                  if (xsePriceContainerSection && !xsePriceContainerSection.getAttribute('aria-label')) {
                    xsePriceContainerSection.setAttribute('aria-label', (strings.priceFor ?? 'Price for {{ name }}').replace('{{ name }}', xseProductName));
                  }
                }
                customElements.whenDefined('x-carousel-item').then(() => {
                  requestAnimationFrame(() => {
                    const shadowCarouselItem = carouselItem.shadowRoot;
                    if (shadowCarouselItem) {
                      const li = shadowCarouselItem.querySelector('li.x-carousel-item');
                      if (li && !li.hasAttribute('role')) {
                        li.setAttribute('role', 'listitem')
                      }
                    } else {
                      console.warn('<x-carousel-item> has no open shadowRoot or hasn\'t rendered it yet');
                    }
                  });
                });
              });
            })
          });
        }
        /**
         * END
         * Fix1: <ul> and <ol> must only directly contain <li>, <script> or <template> elements
         * Fix2: <li> elements must be contained in a <ul> or <ol>
         * Page: Product view
         * Accessibility Tool: AXEDEV
         */

        /**
         * START
         * Fix: Broken ARIA reference
         * Page: Rewards
         * Accessibility Tool: WAVE
         */
        const emailYotpoInput = node.querySelector('.yotpo-email-container input[name="email"]');
        if (emailYotpoInput) {
          const errorId = emailYotpoInput.getAttribute('aria-describedby');
          if (!emailYotpoInput.classList.contains('yotpo-field-error')) {
            const newElem = document.createElement('div');
            newElem.id = errorId;
            newElem.classList.add('sr-only');
            newElem.classList.add(`custom-${errorId}`);
            newElem.setAttribute('aria-hidden', 'true');
            emailYotpoInput.insertAdjacentElement('afterend', newElem);
          }

          // Start watching for class changes (e.g., when .yotpo-field-error is added/removed)
          const classObserver = new MutationObserver((attrMutations) => {
            attrMutations.forEach((attrMutation) => {
              if (attrMutation.type === 'attributes' && attrMutation.attributeName === 'class') {
                const customDiv = emailYotpoInput.parentElement.querySelector(`.custom-${errorId}`);
                if (emailYotpoInput.classList.contains('yotpo-field-error')) {
                  if (customDiv) customDiv.remove();
                } else {
                  if (!customDiv) {
                    const newElem = document.createElement('div');
                    newElem.id = errorId;
                    newElem.classList.add('sr-only');
                    newElem.classList.add(`custom-${errorId}`);
                    newElem.setAttribute('aria-hidden', 'true');
                    emailYotpoInput.insertAdjacentElement('afterend', newElem);
                  }
                }
              }
            });
          });

          classObserver.observe(emailYotpoInput, {
            attributes: true,
            attributeFilter: ['class']
          });
        }
        /**
         * END
         * Fix: Broken ARIA reference
         * Page: Rewards
         * Accessibility Tool: WAVE
         */

        /**
         * START
         * Fix: Spacer images missing alternative text
         * Page: All
         * Accessibility Tool: WAVE
        **/
        const spacerImage = node.matches('img[style*="display: none"]');
        if (spacerImage && !node.hasAttribute('alt')) {
          node.setAttribute('alt', '')
        }

        const spacerImages = node.querySelectorAll('img[style*="display: none"]');
        spacerImages.forEach(spacerImage => {
          if (!spacerImage.hasAttribute('alt')) {
            spacerImage.setAttribute('alt', '')
          }
        });
        /**
         * END
         * Fix: Spacer images missing alternative text
         * Page: All
         * Accessibility Tool: WAVE
        **/

        /**
         * START
         * Fix: <ul> and <ol> must only directly contain <li>, <script> or <template> elements
         * JIRA: B2CECOM-1544
         * Page: All
         * Accessibility Tool: Axedev
        **/
        const ul = document.querySelector('ul.nav-container.level-1');
        if (ul) {
          const anchors = Array.from(ul.childNodes).filter(child => child.nodeName === 'A');
          anchors.forEach(anchor => {
            const li = document.createElement('li');
            ul.insertBefore(li, anchor);
            li.appendChild(anchor);
          });
        }
        /**
         * END
         * Fix: <ul> and <ol> must only directly contain <li>, <script> or <template> elements
         * JIRA: B2CECOM-1544
         * Page: All
         * Accessibility Tool: Axedev
        **/

        /**
         * START
         * Fix 1: <li> elements must be contained in a <ul> or <ol>
         * Fix 2: Empty headings
         * Fix 3: ARIA role should be appropriate for the element
         * JIRA: B2CECOM-1896
         * Accessibility Tool: AXEDEV, WAVE
         */
        const productsGridDiv = node.querySelector('div.products-grid');
        if (productsGridDiv) {
          // Only observe if the products grid contains direct child <li> elements
          const hasDirectLiChildren = productsGridDiv.querySelector(':scope > li') !== null;
          if (hasDirectLiChildren) {
            observeProductItems(productsGridDiv);
          }
        }

        const osanoDialog = node.querySelector?.('div.osano-cm-window__info-dialog');
        if (osanoDialog) {
          observeOsanoDialog(osanoDialog);
        }

        if (node.matches && node.matches('a.swiper-slide')) {
          const swiperSlideAnchor = node;
          if (swiperSlideAnchor.getAttribute('role')) {
            swiperSlideAnchor.removeAttribute('role');
          }
        }

        const yotpoContainerHeadline = node.querySelector('div.yotpo-container-headline[role="heading"]');
        if (yotpoContainerHeadline) {
          if(!yotpoContainerHeadline.textContent.trim()) {
            yotpoContainerHeadline.removeAttribute('role');
          }
        }
        /**
         * END
         * Fix 1: <li> elements must be contained in a <ul> or <ol>
         * Fix 2: Empty headings
         * Fix 3: ARIA role should be appropriate for the element
         * JIRA: B2CECOM-1896
         * Accessibility Tool: AXEDEV, WAVE
         */
      });
    });
  });

  // Start observing the DOM for dynamically added content
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  /**
   * START
   * Fix: Images must have alternative text
   * Page: Rewards
   * Accessibility Tool: AXEDEV
  **/
  waitForElements('img.yotpo-vip-tier-benefit-icon', (benefitImages) => {
    const strings = window.themeStrings ?? {};
    benefitImages.forEach((benefitImage) => {
      if (benefitImage) {
        benefitImage.setAttribute('alt', strings.included ?? 'Included');
      }
    })
  })
  /**
   * END
   * Fix: Images must have alternative text
   * Page: Rewards
   * Accessibility Tool: AXEDEV
  **/

  /**
   * START
   * Fix: Spacer images missing alternative text
   * Page: All
   * Accessibility Tool: WAVE
  **/
  waitForElements('img[style*="display: none"]', function (spacerImages) {
      spacerImages.forEach(spacerImage => {
          if (!spacerImage.getAttribute('alt')) {
            spacerImage.setAttribute('alt', '');
          }
      })
  });
  /**
   * END
   * Fix: Spacer images missing alternative text
   * Page: All
   * Accessibility Tool: WAVE
  **/

});

/**
 * Sets up accessibility attributes for newsletter form submit buttons
 */
function setupNewsletterFormAccessibility() {
  const newsLetterForm = document.querySelector('.team-newsletter-card .team-newsletter__form');
  if (!newsLetterForm) return;

  const emailInput = newsLetterForm.querySelector('input[name="email"]');
  const teamName = emailInput.dataset?.team ? emailInput.dataset.team : '';
  const submitButton = newsLetterForm.querySelector('button[type="submit"]');
  const strings = window.themeStrings ?? {};

  if (submitButton && !submitButton.hasAttribute('aria-label')) {
    submitButton.setAttribute(
      'aria-label',
      teamName
        ? (strings.subscribeToTeamNewsletter ?? 'Subscribe to {{ team }} newsletter').replace('{{ team }}', teamName)
        : strings.subscribeToNewsletter ?? 'Subscribe to newsletter'
    );
  }

  if (emailInput && !emailInput.hasAttribute('aria-label')) {
    emailInput.setAttribute('aria-label', strings.emailAddress ?? 'Email address');
  }
}

/**
 * Waits for an element to appear in the DOM before running a callback
 */
function waitForElement(selector, callback) {
  let attempts = 0;
  const interval = setInterval(() => {
    if (++attempts > 300) { clearInterval(interval); return; }
    const el = document.querySelector(selector);
    if (el) {
      clearInterval(interval);
      callback(el);
    }
  }, 100);
}

/**
 * Waits for elements to appear in the DOM before running a callback
 */
function waitForElements(selector, callback) {
  let attempts = 0;
  const interval = setInterval(() => {
    if (++attempts > 300) { clearInterval(interval); return; }
    const elements = document.querySelectorAll(selector);
    if (elements.length > 0) {
      clearInterval(interval);
      callback(elements);
    }
  }, 100);
}

/**
 * Applies ARIA roles to the product items within the grid
 * @param {*} productsGridDiv
 */
function applyListRoles(productsGridDiv) {
  productsGridDiv.setAttribute('role', 'list');
  productsGridDiv
    .querySelectorAll(':scope > .ne-product-card.product-item')
    .forEach(productItem => {
      productItem.setAttribute('role', 'listitem');
    });
}

/**
 * Observes changes to the product items within the grid and applies ARIA roles
 * @param {*} productsGridDiv
 */
function observeProductItems(productsGridDiv) {
  // Apply once initially
  applyListRoles(productsGridDiv);
  const itemsObserver = new MutationObserver(() => {
    applyListRoles(productsGridDiv);
  });
  itemsObserver.observe(productsGridDiv, {
    childList: true
  });
}

/**
 * Applies heading fallbacks to Osano cookie dialog headings
 * @param {*} osanoCmWindowInfoDialog
 */
function applyOsanoHeadingFallback(osanoCmWindowInfoDialog) {
  const headings = osanoCmWindowInfoDialog.querySelectorAll('p[role="heading"]');
  const strings = window.themeStrings ?? {};

  if (osanoCmWindowInfoDialog.classList.contains('osano-cm-info-dialog--hidden')) {
    // Dialog hidden
    headings.forEach(pHeading => {
      if (!pHeading.textContent.trim()) {
        if (!pHeading.querySelector('.sr-only-fallback')) {
          const srOnlySpan = document.createElement('span');
          srOnlySpan.className = 'sr-only sr-only-fallback';
          srOnlySpan.textContent = strings.cookieDialogHeading ?? 'Cookie dialog heading';
          pHeading.appendChild(srOnlySpan);
        }
      }
    });
  } else {
    // Dialog visible
    headings.forEach(pHeading => {
      const fallbackSpan = pHeading.querySelector('.sr-only-fallback');
      if (fallbackSpan) {
        fallbackSpan.remove();
      }

      if (!pHeading.textContent.trim()) {
        if (!pHeading.querySelector('.sr-only-generic')) {
          const srOnlySpan = document.createElement('span');
          srOnlySpan.className = 'sr-only sr-only-generic';
          srOnlySpan.textContent = strings.cookieDialogHeading ?? 'Cookie dialog heading';
          pHeading.appendChild(srOnlySpan);
        }
      }
    });
  }
}

function setXseImageAlt(img) {
  const carouselItem = img.closest('x-carousel-item');
  const productName = carouselItem?.querySelector('span.xse-prod-name')?.textContent?.trim();
  const isAlt = img.classList.contains('xse-image-alt');
  const strings = window.themeStrings ?? {};
  if (productName) {
    img.setAttribute('alt', isAlt ? (strings.productAlternateViewNamed ?? '{{ name }} - alternate view').replace('{{ name }}', productName) : productName);
  } else {
    img.setAttribute('alt', isAlt ? strings.productAlternateView ?? 'Product alternate view' : strings.productImage ?? 'Product image');
  }
}

function observeOsanoDialog(osanoCmWindowInfoDialog) {
  // Apply once initially
  applyOsanoHeadingFallback(osanoCmWindowInfoDialog);
  const osanoObserver = new MutationObserver(() => {
    applyOsanoHeadingFallback(osanoCmWindowInfoDialog);
  });
  osanoObserver.observe(osanoCmWindowInfoDialog, {
    attributes: true,
    attributeFilter: ['class'], // watch hidden/visible toggle
    childList: true,
    subtree: true // headings may be injected dynamically
  });
}
